<template>
  <div
      class="item"
      :class="{ selected: selectTargetProduct.isSelect, vipBg: isVipBg, normalBg: !isVipBg }"
      @click="selectItem(selectTargetProduct)"
      :style="backgroundStyle"
      v-loading="loadingTargetProduct"
  >
    <div class="title" style="display: flex; align-items: center;">
      <span v-if="selectTargetProduct.productSort===9">
         <img class="plus-icon" :src="isVipIcon" alt=""  style="margin-bottom: 4px;"/>
      </span>
      <span v-if="selectTargetProduct.productSort===1">
        {{
          $t('userinfo.vip.service.1') + `（${$t('common.text.per.station.year', {number: selectTargetProduct?.productNum})}）`
        }}
      </span>
      <span
          v-else-if="selectTargetProduct.productSort===2">{{
          $t('userinfo.vip.service.2') + `（${$t('common.text.per.GB.year', {number: spaceSizeFormat(selectTargetProduct?.productNum, false)})}）`
        }}</span>
      <span
          v-else-if="selectTargetProduct.productSort===3">{{
          $t('userinfo.vip.service.3') + `（${$t('common.text.per.feng.year', {number: selectTargetProduct?.productNum})}）`
        }}</span>
      <span v-else-if="selectTargetProduct.productSort===4">{{
          $t('userinfo.vip.service.4') + `（${$t('common.text.per.year', {number: selectTargetProduct?.productNum})}）`
        }}</span>
        <span v-else-if="selectTargetProduct.productSort===9">{{
          $t('common.zxhy') + `（${$t('home.filter.year')}）`
        }}</span>
      <span v-else>
        {{ `${$t(`${productSortSwitch(selectTargetProduct?.productSort)}`)}` + `（${$t('userinfo.vip.price.units')}）` }}
      </span>
    </div>
     <div class="nowpricebox">
      <div class="nowprice">
        <span class="unit" style="font-size: 24px;">￥</span>
        <span class="intnum">
          {{ displayPrice }}
          <div class="isvip" v-if="showMemberPrice && !(selectTargetProduct?.productSort>5)">
          <div class="vip-price-tag">
            {{ $t('common.product.price.member') }}
            <div class="triangle"></div>
          </div>
        </div>
        </span>
      </div>
    </div>
    <div class="beforeprice">
      {{
        // $t('common.jz', {price: selectTargetProduct?.productPrice})
        showMemberPrice ? ((selectTargetProduct?.productSort > 5) ? "" : $t('common.yj', {price: selectTargetProduct?.productPrice})) : ''
      }}
    </div>
  </div>
</template>

<script setup>
import {defineProps, computed, defineEmits, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import img1 from "@/assets/productIcon/1.png"
import img2 from "@/assets/productIcon/2.png"
import img3 from "@/assets/productIcon/3.png"
import img4 from "@/assets/productIcon/4.png"
import vip from "@/assets/productIcon/vip.png"
import {isEmpty} from "@/utils/mylodash";
import {spaceSizeFormat} from "../../../utils/file";
import {productSortSwitch} from "@/utils/util";
import isVipIcon from '@/assets/usercenter/isvip.png'

const store = useStore();
const route = useRoute()
const props = defineProps({
  item: {
    type: Object,
  },
});
const emit = defineEmits(["selectItems"]);

const selectTargetProduct = computed(() => store.state.buystorage.selectTargetProduct)
const isVipUser = computed(() => store.getters['user/isVipUser'])
const upsellVipChecked = computed(() => store.state.buystorage.upsellVipChecked)

const showMemberPrice = computed(() => {
  return isVipUser.value || upsellVipChecked.value || Number(selectTargetProduct.value?.productSort) > 5
})

const displayPrice = computed(() => {
  const p = selectTargetProduct.value || {}
  const price = showMemberPrice.value ? Number(p.productCheapPrice ?? 0) : Number(p.productPrice ?? 0)
  return price.toFixed(2)
})

const isVipBg = computed(() => selectTargetProduct.value.productSort > 4)
const productBgMap = {
  1: img1,
  2: img2,
  3: img3,
  4: img4,
};
const backgroundStyle = computed(() => {
  const productSort = selectTargetProduct.value.productSort ?? 0;
  console.log(productSort, 'productSort')
  const bgUrl = isVipBg.value
      ? vip
      : productBgMap[productSort]

  return {
    background: `url(${bgUrl}) no-repeat center/cover`,
    transition: 'border 0.2s',
    border: selectTargetProduct.value.isSelect
        ? '1px solid #d93737 !important'
        : '1px solid transparent !important',
  };
})
const selectItem = (value) => {
  emit("selectItems", value);
};


const allUserVip = computed(() => store.state.buystorage.allUserVip)
// 获取商品详情 / 会员详情
const allProductList = computed(() => store.state.buystorage.allProductList)

const loadingTargetProduct = ref(false)

onMounted(async () => {
  if (isEmpty(allUserVip.value)) {
    await store.dispatch("buystorage/getMailProductListApis", 2)
  }
  if (isEmpty(allProductList.value)) {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  }
  if (route.query.indexId) {
    try {
      loadingTargetProduct.value = true
      await store.dispatch("buystorage/getProductDetailApis", {id: route.query.indexId})
      loadingTargetProduct.value = false
    } catch (e) {
      loadingTargetProduct.value = false
    }
  }
})
</script>

<style lang="less" scoped>
.item {
  min-width: 220px;
  height: 113px;
  margin: 0px 20px 25px 0px;
  background-repeat: no-repeat;
  overflow: hidden;
  padding-left: 10px;
  border-radius: 4px;
  cursor: pointer;

  .title {
    height: 14px;
    font-size: 14px;
    font-weight: 600;
    vertical-align: middle;
    color: rgba(0, 0, 0, 0.85);
    line-height: 14px;
    margin-top: 10px;
    margin-bottom: 6px;
  }

  .nowpricebox {
    position: relative;
    display: inline-block;
    // bottom: -24px !important;
  }

  .beforeprice {
    font-size: 13px;
    color: #aaa;
    text-decoration: line-through;
    margin-top: 2px;
  }

  .nowprice {
    font-size: 18px;
    font-weight: 600;
    color: #d93737;

    .unit {
      font-size: 14px;
    }

    .intnum {
      position: relative;
      font-size: 24px;
      letter-spacing: 0;
    }

    .floatnum {
      font-size: 16px;
    }
  }
}


.vip-price-tag {
  width: 42px;
  position: relative;
  left: 113%;
  top: -30px;
  background-color: #F2270C;
  color: #fff;
  font-size: 10px;
  padding: 0 6px;
  height: 14px;
  line-height: 14px;
  border-radius: 3px 3px 3px 0px;
  font-weight: bold;
  text-align: center;
}

/* 下方小三角 */
.triangle {
  position: absolute;
  bottom: -4px;
  left: 3px;
  top: 6px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #F2270C; /* 红色三角向右 */
}

.plus-icon {
  width: 53px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
}
</style>
